module.exports = __webpack_public_path__ + "img/edit-organization.fbe36cc5.png";